import { baseUrl, defaultColors } from "../../../config.js";
import {
  getUrlExtension,
  setDocTitle,
} from "../../../functions/HelperFuncs.js";
import i18n from "../../../functions/i18next.js";
import tinycolor from "tinycolor2";
import i18next from "../../../functions/i18next.js";
import { calculateBrandColors } from "../../../functions/BrandingColor.js";

export default {
  data() {
    return {
      name: null,
      display_name: null,
      analytics: null,
      analyticsError: false,
      google_ai: 0,
      home_screen: null,
      home_screen_changed: false,
      home_screen_url: null,
      home_screen_type: null,
      home_screen_error: false,
      home_logo: null,
      home_logo_url: null,
      home_logo_error: false,
      nav_logo: null,
      nav_logo_url: null,
      brand_color: "#000000",
      brand_color_error: null,
      nav_logo_error: false,
      facebook: null,
      instagram: null,
      linkedin: null,
      pinterest: "",
      youtube: "",
      vimeo: "",
      tiktok: "",
      twitter: null,
      // pinterest: null,
      user: this.$store.state.user,
      role: this.$store.state.role,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      success1: false,
      working1: false,
      success2: false,
      working2: false,
      success3: false,
      working3: false,
      loading: true,
      imageloaded: false,
      imageloaded1: false,
      imageloaded2: false,
      brandColors: defaultColors,
    };
  },
  watch: {
    home_screen: function (newVal, oldVal) {
      if (oldVal) {
        this.home_screen_changed = true;
      }
    },
  },
  created() {
    setDocTitle("Branding", this);

    this.brand_color = this.$store.state.company_full.brand_color;

    this.loading = true;
    this.$axios.get(baseUrl + "/company").then((response) => {
      this.display_name = response.data.display_name;
      this.analytics = response.data.analytics;
      this.google_ai = response.data.google_ai;
      this.name = response.data.name;
      this.facebook = response.data.facebook;
      this.instagram = response.data.instagram;
      this.linkedin = response.data.linkedin;
      this.twitter = response.data.twitter;
      this.pinterest = response.data.pinterest;
      this.youtube = response.data.youtube;
      this.vimeo = response.data.vimeo;
      this.tiktok = response.data.tiktok;

      this.home_screen = response.data.home_screen;
      this.home_logo = response.data.home_logo;
      this.nav_logo = response.data.nav_logo;
      this.loading = false;
    });
  },
  methods: {
    updateGoogleAi(e) {
      this.google_ai = e.currentTarget.checked ? 1 : 0;
    },
    updateBrandColor(inputColor) {
      const color = tinycolor(inputColor);

      if (color.isValid()) {
        //is color
        if (inputColor === "#000" || inputColor === "#000000") {
          //is default
          this.brand_color = "#000000";
          this.brandColors = defaultColors;
        } else {
          //if (hex(inputColor, "#fff") > 8) {
          //contrast is high enough
          //calculate the correct colors
          this.brand_color = inputColor;
          this.calculateColors();
          this.brand_color_error = "";
          /*} else {
            this.brand_color_error = i18next.t("branding.brand_color_to_light");
          }*/
        }

        this.brand_color_error = "";

        //set colors
        // this.setBrandColors();
        this.calculateColors();
      } else {
        this.brand_color_error = i18next.t("branding.brand_color_not_a_color");
      }
    },

    calculateColors() {
      calculateBrandColors(this.brand_color);
    },
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb

      return (usedMb / totalMb) * 100;
    },
    handleScreen() {
      if (
        this.$refs.home_screen.files[0].type == "image/jpg" ||
        this.$refs.home_screen.files[0].type == "image/jpeg" ||
        this.$refs.home_screen.files[0].type == "image/png" ||
        this.$refs.home_screen.files[0].type == "video/mp4"
      ) {
        this.home_screen = this.$refs.home_screen.files[0];
        this.home_screen_url = URL.createObjectURL(this.home_screen);
        this.home_screen_error = false;
        this.home_screen_type = this.$refs.home_screen.files[0].type.includes(
          "video"
        )
          ? "video"
          : "img";
      } else {
        this.home_screen_error = true;
      }
    },
    handleLogo() {
      if (this.$refs.home_logo.files[0].type == "image/png") {
        this.home_logo = this.$refs.home_logo.files[0];
        this.home_logo_url = URL.createObjectURL(this.home_logo);
        this.home_logo_error = false;
      } else {
        this.home_logo_error = true;
      }
    },
    handleNav() {
      if (this.$refs.nav_logo.files[0].type == "image/png") {
        this.nav_logo = this.$refs.nav_logo.files[0];
        this.nav_logo_url = URL.createObjectURL(this.nav_logo);
        this.nav_logo_error = false;
      } else {
        this.nav_logo_error = true;
      }
    },
    showUpload(id) {
      document.getElementById(id).click();
    },
    deleteHomeScreen(event) {
      this.home_screen = null;
      this.home_screen_url = "";
      event.stopPropagation();
      event.preventDefault();
    },
    deleteHomeLogo(event) {
      this.home_logo = null;
      this.home_logo_url = "";
      event.stopPropagation();
      event.preventDefault();
    },
    deleteNavLogo(event) {
      this.nav_logo = null;
      this.nav_logo_url = "";
      event.stopPropagation();
      event.preventDefault();
    },
    submit(place) {
      if (place === 1) {
        this.working1 = true;
      }
      if (place === 2) {
        this.working2 = true;
      }
      if (place === 3) {
        this.analyticsError = false;
        // if(this.analytics !== "" && ! /(UA|YT|MO)-\d+-\d+/i.test(this.analytics)){
        //     this.analyticsError = true;
        //     return;
        // }
        this.working3 = true;
      }
      let formData = new FormData();

      formData.append("id", this.company.id);
      formData.append("name", this.name);
      formData.append("display_name", this.display_name);
      formData.append("analytics", this.analytics);
      formData.append("google_ai", this.google_ai);
      formData.append("home_screen", this.home_screen);
      formData.append("home_logo", this.home_logo);
      formData.append("nav_logo", this.nav_logo);
      formData.append("brand_color", this.brand_color);
      formData.append("facebook", this.facebook);
      formData.append("instagram", this.instagram);
      formData.append("linkedin", this.linkedin);
      formData.append("pinterest", this.pinterest);
      formData.append("youtube", this.youtube);
      formData.append("vimeo", this.vimeo);
      formData.append("tiktok", this.tiktok);
      formData.append("twitter", this.twitter);

      this.$axios
        .post(baseUrl + "/companyupdate", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data) {
            if (this.home_screen_changed) {
              this.$store.state.company_full.home_screen_db = null;
            }
            let that = this;
            if (place === 1) {
              setTimeout(function () {
                that.working1 = false;
                that.success1 = true;
                setTimeout(() => (that.success1 = false), 3000);
              }, 1000);
            }
            if (place === 2) {
              setTimeout(function () {
                that.working2 = false;
                that.success2 = true;
                setTimeout(() => (that.success2 = false), 3000);
              }, 1000);
            }
            if (place === 3) {
              setTimeout(function () {
                that.working3 = false;
                that.success3 = true;
                setTimeout(() => (that.success3 = false), 3000);
              }, 1000);
            }
          } else {
            this.error = i18n.t("login.credentials_match_error");
          }
        })
        .catch((thrown) => {
          if (axios.isCancel(thrown)) {
            this.error = i18n.t("common.something_went_wrong");
          } else {
            this.error = i18n.t("common.something_went_wrong");
          }
        });
    },
    imageLoaded() {
      this.imageloaded = true;
    },
    imageLoaded1() {
      this.imageloaded1 = true;
    },
    imageLoaded2() {
      this.imageloaded2 = true;
    },
    goTo(route) {
      this.$router.push(route);
      // this.show = false;
    },
  },
  computed: {
    homeScreenIsVideo() {
      if (this.home_screen_url || this.home_screen) {
        if (
          this.home_screen && this.home_screen !== "none"
            ? getUrlExtension(this.home_screen) === "mp4"
            : this.home_screen_type === "video"
        ) {
          return true;
        }
      }

      return false;
    },
  },
};
